const products = [
    {
      key: 1,
      title: "Racer Blue",
      content: "The Air Jordan 3 is one of the most timeless silhouettes",
      image:
        "https://static.nike.com/a/images/t_prod_ss/w_640,c_limit,f_auto/08d23366-58e5-4eb0-a634-e6dc3b1bf48a/air-jordan-3-retro-racer-blue-release-date.jpg",
      price: "170.00"
    },
    {
      key: 2,
      title: "Nike Free Metcon 4",
      content: "The Free Metcon combines flexibility with stability",
      image:
        "https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/a479e0f2-53ff-409b-aed2-44a691dd2dd8/free-metcon-4-training-shoe-2g2hts.png",
      price: "135.00"
    },
    {
      key: 3,
      title: "Victory G Lite",
      content: "Experience something new in the Nike Victory G Lite",
      image:
        "https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/d4153965-f155-4908-9e09-6ab9f206fd18/victory-g-lite-golf-shoe-6CKr0N.png",
      price: "110.00"
    },
    {
      key: 4,
      title: "Nike Quest 3",
      content: "The Nike Quest 3 delivers functional versatility",
      image:
        "https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/f36cf44a-1ee6-4fc9-bece-cdb951ab342d/quest-3-running-shoe-bCShkB.png",
      price: "110.00"
    },
    {
      key: 5,
      title: "Nike by You",
      content: "The best sneakers ever",
      image:
        "https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/9bf76883-e4ef-4e6f-9395-528f14743231/custom-nike-internationalist-low-by-you.png",
      price: "198.00"
    }

    
  ];
  
  export default products;
  